export type TErrorResponse = {
  errorStatus: number
  namespace: string
  endpoint: string
  errorMessage: string
  errorObject: any
  errorCode: EErrorCode
}

export enum EErrorCode {
  GenericError = 'GenericError',
  GenericClientError = 'GenericClientError',
  MissingMandatoryParam = 'MissingMandatoryParam',
  NotFound = 'NotFound',
  ContentNotFound = 'ContentNotFound',
  MethodNotAllowed = 'MethodNotAllowed',
  NotAuthorized = 'NotAuthorized',
}
